export const parseBigDecimal = (value: unknown): number | null => {
  if (value == null) return null
  const trimmed = String(value).trim()
  if (!trimmed) return null
  const normalized = trimmed.replace(',', '.')
  const n = Number(normalized)
  return Number.isFinite(n) ? n : null
}

export const formatBigDecimalForApi = (value: unknown): string | null => {
  const n = parseBigDecimal(value)
  if (n == null) return null
  return n.toFixed(2)
}

